<template>
  <div class="c-white-background">
    <MainNavBarWapV2 :object-data="infoHeader" />
    <div class="container colum top-spacing">
      <h5 class="title m-0 c-body2 text-center text-uppercase">
        {{ $t("payPolicy") }}
      </h5>
      <div class="content mt-10">
        <p class="lh-18">
          {{ $t("policyObj.text3") }}
        </p>
        <p class="lh-18">
          {{ $t("policyObj.text4") }}
        </p>
        <p class="lh-18">
          {{ $t("policyObj.text5") }}
        </p>
        <p class="lh-18 fw-600 ">{{ $t("policyObj.text6") }}</p>
        <p class="lh-18 ">
          {{ $t("policyObj.text7") }}
        </p>
        <p class="lh-18">
          {{ $t("policyObj.text8") }}
        </p>
        <div class="ml-20">
          <p class="lh-18 fw-600 m-0">
            {{ $t("policyObj.text9") }}
          </p>
          <p class="lh-18 fw-600 m-0">
            {{ $t("policyObj.text10") }}
          </p>
          <p class="lh-18 fw-600">
            {{ $t("policyObj.text11") }}
          </p>
        </div>
        <p class="lh-18 fw-600">{{ $t("policyObj.text12") }}</p>
        <p class="lh-18 ">
          {{ $t("policyObj.text13") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import MainNavBarWapV2 from "@/layout/WapV2/MainNavBar.vue";

export default {
  name: "police-payment",
  computed: {},
  components: {
    MainNavBarWapV2
  },
  props: {},
  data() {
    return {
      infoHeader: {
        title: this.$t("payPolicy"),
        isShowHomeIcon: true,
        isShowMenu: true
      }
    };
  },
  created() {}
};
</script>
<style scoped>
.top-spacing {
  padding-top: 100px;
}
@media screen and (min-width: 0px) and (max-width: 991px) {
  .top-spacing {
    padding-top: 60px;
  }
}
</style>
